import portImage1 from "../assets/port-img_1.jpg";
import portImage2 from "../assets/port-img_2.jpg";
import javascript from "../assets/javascript.png";
import react from "../assets/react.png";
import sass from '../assets/sass.png';
import profile from '../assets/port-img.png';
import profile2 from '../assets/profile-img.png';

const images = {
  profile,
  profile2,
  portImage1,
  portImage2,
  javascript,
  react,
  sass,
};

export default images;
